import { render, staticRenderFns } from "./yesTable.vue?vue&type=template&id=d96056f8&scoped=true"
import script from "./yesTable.vue?vue&type=script&lang=js"
export * from "./yesTable.vue?vue&type=script&lang=js"
import style0 from "./yesTable.vue?vue&type=style&index=0&id=d96056f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96056f8",
  null
  
)

export default component.exports